import * as React from "react";
const SvgPlay = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 10 14", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0,1.8v10.4c0,.8.9,1.3,1.5.8l8.1-5.2c.6-.4.6-1.3,0-1.7L1.5,1c-.7-.4-1.5,0-1.5.8Z" }));
export default SvgPlay;
